import { createContext, useState, useContext, useEffect } from "react";

const ApplicatorContext = createContext();

const API_URL = process.env.REACT_APP_API_URL; // Ensure this matches your backend URL

export const ApplicatorProvider = ({ children }) => {


  const session = JSON.parse(localStorage.getItem("userSession") || "{}");

  const [applicatorId, setApplicatorId] = useState(session?.applicatorId ?? null);
  
  const [companyName, setCompanyName] = useState(
    localStorage.getItem("companyName") || "",
  );

  // Load from localStorage on mount
  useEffect(() => {
    const savedName = localStorage.getItem("companyName");
    if (savedName) {
      setCompanyName(savedName);
    }
  }, []);


//   useEffect(() => {
//    const username = process.env.REACT_APP_API_USERNAME;
//     const password = process.env.REACT_APP_API_PASSWORD;
//     const credentials = `${username}:${password}`;
//     const encodedCredentials = btoa(credentials); // Base64 encode the credentials

//   const fetchApplicatorId = async () => {
//     try {
//       const response = await fetch(
//         `${API_URL}/api/applicator/me`, // CHANGEEEEEE
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Basic ${encodedCredentials}`,
//           },
//         }
//       );

//       if (response.ok) {
//         const data = await response.json();

//         const id = data?.data?.applicator?.id; // CHECKKKKK

//         console.log("Fetched applicatorId:", id);

//         setApplicatorId(id);
//       }
//     } catch (error) {
//       console.error("Error fetching applicatorId:", error);
//     }
//   };

//   if (!applicatorId) {
//     fetchApplicatorId();
//   }
// }, [applicatorId]);



 
  useEffect(() => {
    const username = process.env.REACT_APP_API_USERNAME;
    const password = process.env.REACT_APP_API_PASSWORD;
    const credentials = `${username}:${password}`;
    const encodedCredentials = btoa(credentials); // Base64 encode the credentials

    if (!applicatorId || companyName) return;

    const fetchCompanyName = async () => {
      if (applicatorId && !companyName) {
        try {
          const response = await fetch(
            `${API_URL}/api/applicator/${applicatorId}`,
            {
              method: "GET",
              headers: { Authorization: `Basic ${encodedCredentials}` },
            },
          );

          if (response.ok) {
            const responseData = await response.json();
            // console.log(responseData)
            setCompanyName(responseData?.data?.applicator?.companyName);
          }
        } catch (error) {
          console.error("Error refetching company name:", error);
        }
      }
    };

 if (!companyName) {
    fetchCompanyName();
  }
  }, [applicatorId, companyName]);

console.log("Applicator ID:", applicatorId);
console.log("Company Name:", companyName);

  // Save to localStorage whenever values change
  useEffect(() => {
    if (applicatorId) {
      localStorage.setItem("applicatorId", applicatorId);
    }
    if (companyName) {
      localStorage.setItem("companyName", companyName);
    }
  }, [applicatorId, companyName]);

  return (
    <ApplicatorContext.Provider
      value={{ applicatorId, setApplicatorId, companyName, setCompanyName }}
    >
      {children}
    </ApplicatorContext.Provider>
  );
};

export const useApplicator = () => useContext(ApplicatorContext);
